import { render } from "./Home.vue?vue&type=template&id=bda6db56"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=bda6db56&lang=css"

import exportComponent from "/var/www/html/amatra-frontend-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__